<div class="bi-reponsive forgot-login-flow setup-password">
    <div class="form-section">
        <div class="form-section-inner">
            <h3>Set new password</h3>
            <p>Please enter a new password<br>for your account</p>
            <div class="entry-form">
                <div class="password-field">
                    <input type="password" class="form-input-text" placeholder="New password"
                        [(ngModel)]="newPassword" (input)="validatePassword()" />
                    <div class="password-status" *ngIf="passwordValid">OK</div>
                </div>
                <div class="password-field">
                    <input type="password" class="form-input-text" placeholder="Confirm password"
                        [(ngModel)]="confirmPassword" (input)="validateConfirmPass()" />
                </div>
                <div class="errorMessagespan">{{cPassErrMsg}}</div>
            </div>

            <div class="password-policy">
                <div class="pass-strength-grp">
                    <div id="length" class="txt-danger">Minimum 8 characters length</div>
                    <div id="usernameMatch" class="txt-danger">Does not match username</div>
                    <div id="capital" class="txt-danger">At least one UPPERCASE letter</div>
                    <div id="letter" class="txt-danger">At least one lowercase letter</div>
                    <div id="number" class="txt-danger">A combination of letters and numbers</div>
                    <div id="char" class="txt-danger">At least one special character, e.g., ! @ # ? ]</div>
                </div>
            </div>

        </div>
    </div>

    <div class="form-group pb10 frm-btn-container">
        <div class="">
            <button class="btn-next" [disabled]="!proceed"  clickable (click)="setupPassword()" [disabled]="!proceed"><i class=""></i></button>
        </div>
    </div>

</div>